'use client';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';

import { addToCart } from '@eliadmin/core/src/api/cart/cart-api';
import { CacheKey } from '@eliadmin/core/src/api/constants';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useMutation, useQueryClient } from '@tanstack/react-query';

// Preserve Fervi's auth-scoped exact cart invalidation without mounting checkout mutations.
export function useAddToCart() {
  const queryClient = useQueryClient();
  const { queryKey: cartQueryKey } = useCartQueryOpts();
  const authToken = useCustomerStore(state => state.me?.authToken);
  return useMutation({
    meta: { affectsCart: true },
mutationFn: (req: Omit<Parameters<typeof addToCart>[0], 'authToken'>) =>
      addToCart({ ...req, authToken }),
    onSettled: () => {
      queryClient.invalidateQueries({ exact: true, queryKey: cartQueryKey });
      queryClient.invalidateQueries({ exact: false, queryKey: [CacheKey.SHIPMENTS] });
      queryClient.invalidateQueries({ exact: false, queryKey: [CacheKey.CART_PAYMENTS] });
    },
  });
}
